<template>
  <div class="item" :class="production.checked ? 'checked' : ''">
    <div class="sellout" v-if="production.sellOut">
      <span>首发售罄</span>
    </div>
    <div class="item-status flex-center-center" v-if="productionData.userType == 0"
      :style="{ 'background-color': auditStatus[auditStatusColor.auditStatus] }">
      <span> {{ auditStatus[productionData.auditStatus] }}</span>
    </div>
    <div class="blindBoxLevel" :class="'blindBoxLevel-' + production.levelName" v-if="production.levelName">
      <span>{{ production.levelName }}</span>
    </div>
    <div class="js"
      v-if="production.nftNumberVO && production.nftNumberVO.ownerUserType == 0 && production.nftNumberVO.sellStatus == 0 && production.nftNumberVO.quantity == 1 && jsFlag">
      <span>挂售</span>
    </div>
    <img
      :src="production.coverPicture ? production.coverPicture + parameters :  production.picture + parameters"
      class="img" :alt="'女娲NVWA-' + production.nftName" @click="info(production.nftId)" />
    <!-- <img
      v-if="production.collected"
      src="../../assets/images/icon/collect-grey-icon.png"
      class="collect"
      alt=""
    /> -->
    <!-- <img v-else src="../../assets/images/icon/collected-icon.png" class="collect" alt="" /> -->
    <!-- <el-checkbox v-if="attributes.checked" v-model="production.checked"></el-checkbox> -->
    <div v-if="production.buyTime" class="time flex-center-center" @click="info(production.nftId)">

      <div class="time-div flex-center-center" v-if="production.timeGet">
        <p class="title">发售倒计时</p>
        <p class="buytime">
          <span v-if="production.timeD > 0">{{ production.timeD + '天' }}</span> {{ production.timeH > 9 ?
              production.timeH : '0' + production.timeH
          }}:{{
    production.timeM > 9 ? production.timeM : '0' + production.timeM
}}:{{ production.timeS > 9 ? production.timeS : '0' + production.timeS }}
        </p>
      </div>
      <div class="time-div flex-center-center" v-else>

        <p class="loading title">加载中...</p>
      </div>
    </div>
    <div class="price flex-around-start">
      <div class="left flex-between-start">
        <p class="title">{{ production.nftName }}</p>
        <p v-if="production.nftNumberVO && production.nftNumberVO.sourceType === 1 && resourceTypeFlag"
          class="resourceType" :class="production.isCopy ? '' : 'resourceType-no'">好友赠送</p>
      </div>
      <div v-if="production.isCopy === 1 && production.nftNumberVO && !indexHidden" class="isCopy flex-between-center">
        <span class="number"># {{ production.nftNumberVO.nftNo }} <span>/ {{ production.quantity }}</span></span>
        <span class="icon">¥<span class="num">{{ production.price ||
            '--'
        }}</span></span>

      </div>
      <div v-else class="isCopy flex-between-center">
        <span class="number">&nbsp;</span>
        <span class="icon">¥<span class="num">{{ production.price ||
            '--'
        }}</span></span>
      </div>
      <div class="right flex-between-center">
        <div class="user-div flex-start-center" @click="
          routeLink('/creator', {
            userId: production.ownerId,
            userType: production.ownerUserType
          })
        ">
          <!-- <img class="head" v-if="production.nftNumberVO" :src="production.headPortrait || headImg" alt="头像" /> -->
          <img class="head" :src="production.headPortrait + parametersHead || headImg" alt="头像" />
          <!-- <span class="user" v-if=" production.nftNumberVO">{{ production.nftNumberVO.ownerUserName }}</span> -->
          <span class="user">{{ production.nickName }}</span>
        </div>
        <!-- <p v-if="exchange" class="exchange">兑换</p>
        <p v-else> -->
      </div>

    </div>
  </div>
</template>

<script>

import headImg from '../../assets/images/head.png'
import { getSysTime } from '../../request/api.js'
import { ossParameters, encode, ossParameters1 } from '../../assets/js/globle.js'
export default {
  props: {
    attributes: {
      type: Object,
      default: function () {
        return {
          checked: false,
          editFlag: false
        }
      }
    },
    systemTime: {
      type: Number,
      default: function () {
        return ''
      }
    },
    indexHidden: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    jsFlag: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    resourceTypeFlag: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    productionData: {
      type: Object,
      default: function () {
        return {
          buyTime: '',
          auditStatus: '',
          isExchange: '',
          nftDesc: '',
          nftId: '',
          nftName: '',
          ownerId: '',
          picture: '',
          price: '',
          quantity: '',
          recommendType: '',
          reviewer: '',
          type: '',
          userId: '',
          userType: '',
          worksId: '',
          timeD: '',
          timeH: '',
          timeM: '',
          timeS: '111',
          timeGet: false,
          nftNumberVO: {

          }
        }
      }
    },
    exchange: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  watch: {
    productionData: {
      immediate: true, // 这句重要
      handler(val) {
        this.production = val
      },
      deep: true
    }
  },

  data() {
    return {
      parameters: '',
      parametersHead: ossParameters1(),
      headImg: headImg,
      data: this.attributes,
      production: {

        nftNumberVO: {

        }
      },
      d: '',
      h: '',
      m: '',
      s: '',
      openTime: '',
      auditStatus: ['待上链', '待审核', '已上架', '上架审核未通过', '已下架', '上链失败', '待上架', '铸造审核中', '铸造审核未通过', '上架审核中', '封禁', '已退款'],
      auditStatusColor: ['#989898', '#989898', '#E8721D', '#EF4848', '#989898', '#989898', '#989898', '#358EF5', '#EF4848', '#358EF5', '#989898', '#989898']
      // timeGet: false,
      // systemSelfTime: ''
    }
  },
  created() {
    console.log(this.productionData)
    // let systemTime = this.systemTime
    // this.systemSelfTime = systemTime
    this.parameters = ossParameters()
    // this.getSTime()
    // console.log(this.productionData)
  },
  mounted() {
    // this.getTime()
    // setInterval(() => {
    //   console.log(this.productionData.timeS)
    // }, 1000)
  },
  beforeDestroy() {
    // clearInterval(this.interval)
  },
  methods: {
    getSTime() {
      this.openTime = Math.floor(new Date(this.production.buyTime).getTime()) / 1000
    },
    info(id) {
      let userVO = JSON.parse(localStorage.getItem('userVO'))
      if (this.productionData.userId === userVO.userId &&
        this.productionData.userType !== 1) {
        let query = {
          nftId: id,
          isCopy: this.productionData.isCopy
          // nftNo: this.productionData.nftNumberVO.nftNo
        }
        this.$router.push({
          path: '/auditInfo',
          query: {
            info: encode(JSON.stringify(query))
          }
        })
        return
      }

      if (userVO && this.productionData.ownerId === userVO.userId && this.productionData.ownerUserType !== 1) {
        // this.$router.push({
        //   path: '/NFT',
        //   query: {
        //     nftId: id,
        //     isCopy: this.productionData.isCopy,
        //     // nftNo: this.productionData.nftNumberVO.nftNo
        //   }
        // })
      } else {
        if (this.productionData) {
          let query = {
            nftId: id,
            isCopy: this.productionData.isCopy
            // nftNo: this.productionData.nftNumberVO.nftNo
          }
          encode(JSON.stringify(query))
          this.$router.push({
            path: '/info',
            query: {
              info: encode(JSON.stringify(query))
            }
          })
        } else {
          this.$router.push({
            path: '/info',
            query: {
              nftId: id
            }
          })
        }
      }
    },
    routeLink(path, query) {
      this.$router.push({
        path: path,
        query: query
      })
    }
    // getTime () {
    //   const openTime = this.production.buyTime
    //   if (!openTime && new Date(openTime).getTime() < this.systemTime) {
    //     return false
    //   }
    //   this.interval = setTimeout(() => {
    //     const openTimestamp = Math.floor(new Date(openTime).getTime() / 1000)
    //     const nowDate = this.systemSelfTime
    //     // console.log(openTimestamp, nowDate)
    //     this.d = Math.floor((openTimestamp - nowDate) / 24 / 3600)
    //     this.h = Math.floor((openTimestamp - nowDate - this.d * 24 * 3600) / 3600)
    //     this.m = Math.floor((openTimestamp - nowDate - this.d * 24 * 3600 - this.h * 3600) / 60)
    //     this.s = Math.floor(
    //       openTimestamp - nowDate - this.d * 24 * 3600 - this.h * 3600 - this.m * 60
    //     )
    //     if (this.systemSelfTime) {
    //       this.timeGet = true
    //     }
    //     if (openTimestamp - nowDate < 0) {
    //     } else {
    //       if (this.systemSelfTime) {
    //         this.systemSelfTime++
    //       }

    //       this.getTime()
    //     }
    //   }, 1000)
    // }
  }
}
</script>

<style lang="scss" scoped>
.item {
  width: 278px;
  // height: 522px;

  border-radius: 2px;
  position: relative;
  background-color: white;
  cursor: pointer;

  &:hover {
    box-shadow: 11px 11px 27px 0px rgba(0, 0, 0, 0.09);
    transform: scale(1.01);
    // .time {
    //   display: none;
    // }
  }

  @media screen and(max-width:768px) {
    width: 48%;
    height: 260px;
    // padding: 0 20px;
  }

  .sellout {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #C1C1C1;
    width: 140px;
    height: 42px;
    background: #C1C1C1;
    border-radius: 10px 0px 89px 0px;
    line-height: 42px;
    text-align: center;
    font-size: 16px;
    color: #fff;

    @media screen and(max-width:768px) {
      width: 84px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
  }

  .item-status {
    position: absolute;
    top: 16px;
    right: 0;
    // width: 100px;
    padding: 10px 15px;
    height: 28px;
    background: #E8721D;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.0500);
    border-radius: 14px 0px 0px 14px;

    span {
      font-size: 14px;
      color: white;
    }
  }

  .item-status {
    // background: #989898;
    // background: #358EF5;
    // background: #EF4848;
    // background: #989898;
  }

  .js {
    position: absolute;
    top: 0;
    right: 0;
    width: 66px;
    height: 28px;
    background: #E8721D;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 2px 0px 0px 14px;
    line-height: 28px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .blindBoxLevel {
    position: absolute;
    top: 18px;
    left: 0;
    background-color: #C1C1C1;
    width: 66px;
    height: 28px;

    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 0px 14px 14px 0px;
    line-height: 28px;
    text-align: center;
    font-size: 16px;
    color: #fff;

    @media screen and(max-width:768px) {
      width: 84px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
  }

  .blindBoxLevel-Ass {
    background-color: #fff;
  }

  .blindBoxLevel-Ass {
    background-color: #fff;
  }

  .blindBoxLevel-A {
    background-color: #B42A0E;
  }

  .blindBoxLevel-B {
    background-color: #B42A0E;
  }

  .blindBoxLevel-C {
    background-color: #B42A0E;
  }

  .blindBoxLevel-D {
    background-color: #B42A0E;
  }

  .blindBoxLevel-N {
    background-color: #A44C31;
  }

  .blindBoxLevel-R {
    background-color: #53C4F7;
  }

  .blindBoxLevel-UR {
    background-color: #F7B742;
  }

  .blindBoxLevel-EXR {
    background-color: #854AE0;
  }

  .blindBoxLevel-SR {
    background-color: #7193F6;
  }

  .blindBoxLevel-SSR {
    background: linear-gradient(270deg, #F5AB3E 0%, #E8721D 100%);
  }

  .img {
    width: 100%;
    height: 278px;
    border-radius: 2px;
    object-fit: cover;

    @media screen and(max-width:768px) {
      width: 100%;
      height: 188px;
      border-radius: 2px;
    }
  }

  .time {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 278px;
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 11px 11px 27px 0px rgba(0, 0, 0, 0.09);
    border-radius: 2px 2px 0px 0px;
    backdrop-filter: blur(5px);

    @media screen and(max-width:768px) {
      width: 100%;
      height: 188px;
    }

    .time-div {
      width: 209px;
      height: 60px;
      background: rgba(255, 255, 255, 0.3);
      box-shadow: 11px 11px 27px 0px rgba(0, 0, 0, 0.09);
      border-radius: 5px;
      border: 1px solid #ffffff;
      flex-direction: column;

      @media screen and(max-width:768px) {
        width: 80%;
        height: 40px;
      }

      .title {
        font-size: 12px;
        color: white;
        line-height: 18px;

        @media screen and(max-width:768px) {
          font-size: 14px;
        }
      }

      .loading {
        font-size: 20px;

        @media screen and(max-width:768px) {
          font-size: 16px;
        }
      }

      .buytime {
        font-size: 20px;
        color: white;

        @media screen and(max-width:768px) {
          font-size: 12px;
        }
      }
    }
  }

  /deep/ .el-checkbox {
    position: absolute;
    top: 24px;
    left: 18px;

    .el-checkbox__label {
      color: #e8721d;
    }

    .is-checked {
      .el-checkbox__inner {
        background-color: #e8721d;
        border-color: #e8721d !important;
      }
    }

    .el-checkbox__inner {
      // background-color: #e8721d;
      border-color: #e8721d !important;
    }
  }

  .collect {
    position: absolute;
    top: -36px;
    right: -36px;
    width: 145px;
    height: 145px;
    cursor: pointer;
  }

  .price {
    // position: absolute;
    // bottom: 0;
    width: 100%;
    // height: 107px;

    background: #ffffff;
    border-radius: 0 0 2px 2px;
    box-shadow: 11px 11px 27px 0px rgba(0, 0, 0, 0.09);
    flex-direction: column;

    @media screen and(max-width:768px) {
      width: 100%;
      min-height: 70px;
      height: auto;
      padding: 0 7px;
    }

    .left {
      // @extend .flex-around-start;
      flex-direction: column;
      width: 100%;
      position: relative;
      margin: 12px 0 0 0;
      padding: 0 20px;
      line-height: 22px;

      @media screen and(max-width:768px) {
        height: 80%;
        padding: 0;
        margin: 8px 0 0 0;
      }

      .title {
        font-size: 16px;
        width: 100%;
        color: #494949;
        overflow: hidden;
        //隐藏部分显示为省略号
        text-overflow: ellipsis;
        //禁止文本自动换行
        white-space: nowrap;

        // padding: 0 20px;
        @media screen and(max-width:768px) {
          font-size: 14px;
          width: 100px;
          overflow: hidden;
          //隐藏部分显示为省略号
          text-overflow: ellipsis;
          //禁止文本自动换行
          white-space: nowrap;
          // padding: 0 20px;
        }
      }

      .resourceType {
        position: absolute;
        right: 10px;
        top: -5px;
        font-size: 13px;
        font-weight: 400;
        color: #E8721D;
        line-height: 18px;
        text-shadow: 11px 11px 27px rgba(0, 0, 0, 0.09);
        padding: 5px 12px;
        background: #F7EDE7;

        @media screen and(max-width:768px) {
          height: 80%;
          background: #fff;
          padding: 0;
          top: 24px;
        }
      }

      .resourceType-no {
        top: 10;

        @media screen and(max-width:768px) {
          top: 2px
        }
      }
    }

    .isCopy {
      line-height: 20px;
      flex-shrink: 0;
      width: 100%;
      margin: 5px 0 0 0;
      padding: 0 20px 12px 20px;
      border-bottom: 1px solid #EDEDED;

      @media screen and(max-width:768px) {
        line-height: 20px;
        padding: 0;
      }

      span {
        font-size: 12px;
        // cursor: pointer;
      }

      .number {
        color: rgba(0, 0, 0, 0.5);
      }

      .icon,
      .num {
        font-size: 18px;

        font-weight: 500;
        color: #191919;
        line-height: 21px;
        text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
      }
    }

    .right {
      // display: none;
      // @extend .flex-between-center;
      width: 100%;
      height: 35px;
      padding: 0 20px;

      @media screen and(max-width:768px) {
        height: 23px;
        padding: 0;
      }

      .user-div {
        // @extend .flex-start-center;
        cursor: pointer;

        @media screen and(max-width:768px) {
          width: 75px;
        }

      }

      .head {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        margin-right: 10px;

        @media screen and(max-width:768px) {
          width: 16px;
          height: 16px;
        }
      }

      .user {
        font-size: 14px;
        font-weight: 400;
        color: #788391;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 85px;
      }

      .platform {
        font-size: 16px;
        font-weight: 600;
        color: #E8721D;
        line-height: 22px;
        text-shadow: 11px 11px 27px rgba(0, 0, 0, 0.09);
      }

      .exchange {
        padding: 6px 32px;
        border-radius: 15px;
        font-size: 14px;
        line-height: 20px;
        color: #fff;
        background-color: #E8721D;
        cursor: pointer;
      }

      .icon {
        font-size: 16px;
        color: #494949;

        @media screen and(max-width:768px) {
          font-size: 12px;
          line-height: 18px;
        }
      }

      .num {
        font-size: 28px;
        color: #494949;

        @media screen and(max-width:768px) {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }
}

.checked {
  border: 5px solid #e8721d;
}
</style>



// WEBPACK FOOTER //
// src/conponents/marketCard/index.vue